import type { AnalyticsPerformance } from './types'

export type PerformanceProviderTaxLotSummary = {
  totalRealizedGainProvider: number
  totalUnrealizedGainProvider: number
  affectedRowCount: number
}

export const EMPTY_PROVIDER_TAX_LOT_SUMMARY: PerformanceProviderTaxLotSummary = {
  totalRealizedGainProvider: 0,
  totalUnrealizedGainProvider: 0,
  affectedRowCount: 0,
}

export const getPerformanceProviderTaxLotSummary = (
  performance: AnalyticsPerformance[],
): PerformanceProviderTaxLotSummary =>
  performance.reduce((summary, item) => {
    // Absolute totals show provider-provenance magnitude without positive/negative values canceling out.
    const realizedGainProvider = Math.abs(item.realized_gain_provider ?? 0)
    const unrealizedGainProvider = Math.abs(item.unrealized_gain_provider ?? 0)
    return {
      totalRealizedGainProvider: summary.totalRealizedGainProvider + realizedGainProvider,
      totalUnrealizedGainProvider: summary.totalUnrealizedGainProvider + unrealizedGainProvider,
      affectedRowCount: summary.affectedRowCount + (
        realizedGainProvider || unrealizedGainProvider ? 1 : 0
      ),
    }
  }, EMPTY_PROVIDER_TAX_LOT_SUMMARY)
